import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";

// Pages
import { Landing } from "./pages/Landing";
import { BranchPage } from "./pages/BranchPage";
import { SiteWeb } from "./pages/SiteWeb";
import { DevisSimulateur } from "./pages/DevisSimulateur";
import { CahierDesCharges } from "./pages/CahierDesCharges";
import { Register } from "./pages/Register";
import { ThankYou } from "./pages/ThankYou";
import { Quote } from "./pages/Quote";
import { Contract } from "./pages/Contract";
import { Testimonials } from "./pages/Testimonials";
import { Appointment } from "./pages/Appointment";
import { Admin } from "./pages/Admin";
import { Login } from "./pages/Login";
import { PaymentSuccess } from "./pages/PaymentSuccess";
import { PaymentCancel } from "./pages/PaymentCancel";
import { MentionsLegales } from "./pages/MentionsLegales";
import { CGV } from "./pages/CGV";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/formation" element={<BranchPage />} />
              <Route path="/pme" element={<BranchPage />} />
              <Route path="/freelance" element={<BranchPage />} />
              <Route path="/employes" element={<BranchPage />} />
              <Route path="/siteweb" element={<SiteWeb />} />
              <Route path="/devis-simulateur" element={<DevisSimulateur />} />
              <Route path="/cahier-des-charges" element={<CahierDesCharges />} />
              <Route path="/cahier-des-charges/:briefId" element={<CahierDesCharges />} />
              <Route path="/register" element={<Register />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/quote/:quoteId" element={<Quote />} />
              <Route path="/contract/:contractId" element={<Contract />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/appointment" element={<Appointment />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/login" element={<Login />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/cgv" element={<CGV />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
